import { createClient } from '@supabase/supabase-js';
import { generateCsrfToken, storeCsrfToken } from '../utils/csrf';
import type { Database } from '../types/supabase';

if (!import.meta.env.VITE_SUPABASE_URL) {
  throw new Error('Missing environment variable: VITE_SUPABASE_URL');
}

if (!import.meta.env.VITE_SUPABASE_ANON_KEY) {
  throw new Error('Missing environment variable: VITE_SUPABASE_ANON_KEY');
}

// Generate and store CSRF token on client initialization
const csrfToken = generateCsrfToken();
storeCsrfToken(csrfToken);

// Remove any trailing slashes from the URL
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL.replace(/\/$/, '');

export const supabase = createClient<Database>(
  supabaseUrl,
  import.meta.env.VITE_SUPABASE_ANON_KEY,
  {
    auth: {
      persistSession: false,
      detectSessionInUrl: false,
      autoRefreshToken: true,
      debug: true
    },
    global: {
      headers: {
        'X-CSRF-Token': csrfToken
      }
    },
    realtime: {
      params: {
        eventsPerSecond: 10
      }
    },
    db: {
      schema: 'public'
    }
  }
);